// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: 'files',
        component: () =>
            import('@/pages/[organisation]/hr/team-member-files/files.vue'),
        name: 'human-resource.team-member-files.search-team-member-files',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.files.view-team-member-files',
        },
    },
    {
        path: 'files/new',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-files" */ '@/pages/[organisation]/hr/team-member-files/team-member-file/new.vue'),
        name: 'human-resource.team-member-files.create-team-member-file',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.files.create-team-member-file',
        },
    },
    {
        path: 'files/:fileId',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-files" */ '@/pages/[organisation]/hr/team-member-files/team-member-file/[id].vue'),
        name: 'human-resource.team-member-files.view-team-member-file',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.files.view-team-member-files',
        },
    },
    {
        path: 'files/:fileId/edit',
        component: () =>
            import(/* webpackChunkName: "human-resource.team-member-files" */ '@/pages/[organisation]/hr/team-member-files/team-member-file/[id]/edit.vue'),
        name: 'human-resource.team-member-files.update-team-member-file',
        meta: {
            loginRequired: true,
            permission: 'access.human-resource.files.update-team-member-file',
        },
    },
];
